import { render, staticRenderFns } from "./OnboardingBoardCreate.vue?vue&type=template&id=14641088&scoped=true&lang=pug&"
import script from "./OnboardingBoardCreate.vue?vue&type=script&lang=js&"
export * from "./OnboardingBoardCreate.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingBoardCreate.vue?vue&type=style&index=0&id=14641088&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14641088",
  null
  
)

export default component.exports